// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3EtNv","row":"Node_row__1vabY","label":"Node_label__2K5xj","footer":"Node_footer__27wBz"};